<template>
  <div class="content">
    <el-row :gutter="12">
      <el-col :span="12" class="fix__top">
        <el-input
          class="style-fullWidth"
          v-model="search"
          size="medium"
          placeholder="Tìm kiếm"
          prefix-icon="el-icon-search"
          @keydown.enter.exact.native="searchTree"
        ></el-input>
      </el-col>
    </el-row>

    <hashtag-common
      @selectTags="selectTags"
      :groupTypeId="GROUPS.GROUP_TYPE_ID.DON_VI"
    />

    <VuePerfectScrollbar
      class="scroll-scope listCompanies"
      :settings="settings"
    >
      <el-tree
        :data="roots"
        :filter-node-method="filterTree"
        ref="departmentTree"
        class="filter-tree"
        default-expand-all
      >
        <div
          class="custom-tree-node flex-row flex__between width__100"
          slot-scope="{ node, data }"
        >
          <div class="field-1" @click.native.stop="() => false">
            <span>
              <el-checkbox
                v-model="data.checked"
                v-if="data.isHandlerNode"
                @change="checkedChange(data)"
              ></el-checkbox>
              <span
                v-if="
                  data.nodeType === DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
                "
              >
                &nbsp;
                <span class="font-weight__bold">
                  {{ data.userDeptRole.fullName }}
                </span>
                <span class="font-size__small font-italic">
                  ({{ data.userDeptRole.positionName }})
                </span>
              </span>
              <span v-else>&nbsp;{{ getNodeLabel(data) }}</span>
            </span>

            <span
              class="margin-right-10"
              v-if="data.children && data.children.length"
              @click.native.stop="() => false"
            >
              <el-tooltip content="Chọn tất cả" placement="top">
                <i
                  class="el-icon-circle-check margin-left-10"
                  @click.stop="() => checkedAll(data, true)"
                ></i>
              </el-tooltip>
              <el-tooltip content="Bỏ chọn tất cả" placement="top">
                <i
                  class="el-icon-circle-close margin-left-10"
                  @click.stop="() => checkedAll(data, false)"
                ></i>
              </el-tooltip>
            </span>
          </div>
        </div>
      </el-tree>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import constants from "../../../constants";
import utils from "../../../services/utils";
import h from "../../../services/h";
import handlersTreeMixin from "../../../mixins/handlersTreeMixin";
import departmentService from "../../../services/departmentService";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import HashtagCommon from "../../doc-in/components/chuyenXuLy-hashtag";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import nextStepInfoViewService from "../../../services/nextStepInfoViewService";

export default {
  name: "banhanh-department-tree",
  mixins: [handlersTreeMixin],
  components: {
    HashtagCommon,
    VuePerfectScrollbar
  },
  props: ["docId", "selectedReceiverIds", "selectedHandlerIds"],
  data() {
    return {
      DEPARTMENT_TREE: constants.DEPARTMENT_TREE,
      DEPARTMENT: constants.DEPARTMENT,
      GROUPS: constants.GROUPS,
      search: null,
      settings: {maxScrollbarLength: 750},
      selectedTagData: null,
      nextStepInfoViews: null,
    };
  },

  created() {
    this.loadToDepartments()
      .then(() =>
        Promise.all([this.loadHandlers(), this.loadNextStepInfoViews()])
      )
      .then(() => this.buildNodes())
      .then(() => this.initByDocReceivers());
  },

  methods: {
    getToDepartments() {
      let toDepartments = [];
      let queue = [];
      queue.push(...this.roots);
      let index = 0;
      while (index < queue.length) {
        let data = queue[index];
        if (
          data.isHandlerNode &&
          data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
          data.checked
        )
          toDepartments.push(data.department);
        queue.push(...(data.children || []));
        index++;
      }
      return toDepartments;
    },

    getToHandlers() {
      let toHandlers = [];
      let queue = [];
      queue.push(...this.roots);
      let index = 0;
      while (index < queue.length) {
        let data = queue[index];
        if (
          data.isHandlerNode &&
          data.nodeType ===
          constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE &&
          data.checked
        )
          toHandlers.push(data.userDeptRole);
        queue.push(...(data.children || []));
        index++;
      }
      return toHandlers;
    },

    getToHandlersData() {
      return h.collect(this.getToHandlers(), userDeptRole => {
        let nextStepInfoView = h.find(this.nextStepInfoViews, nextStepInfoView_ =>
          nextStepInfoViewService.isMatchingWithUserDeptRole(userDeptRole, nextStepInfoView_)
        );
        let handler = {userDeptRole: userDeptRole};
        if (nextStepInfoView) {
          handler.vbStepInfoId = nextStepInfoView.vbStepInfoId;
          handler.stepId = nextStepInfoView.id;
          handler.flowId = nextStepInfoView.flowId;
        }
        return handler;
      })
    },

    loadToDepartments() {
      return departmentService
        .findAllForBanHanh(this.docId)
        .then(response => (this.departmentHandlers = response.data.filter(item => item.id !== "ROOT")));
    },

    loadHandlers() {
      // if(this.$store.getters.userDeptRole.deptId === "TCT") {
      //  return userDeptRoleViewService.search(null, null, "TCT").then(res => {
      //    this.userDeptRoleHandlers = res.data.filter(item => item.roleCode === constants.ROLE.CODE.LANH_DAO)
      //  })
      //}
      return userDeptRoleViewService
        .findAllForBanHanh(this.docId)
        .then(response => {
          this.userDeptRoleHandlers = response.data
        });
    },

    loadNextStepInfoViews() {
      return nextStepInfoViewService
        .findAllForBanHanh(this.docId)
        .then(response => (this.nextStepInfoViews = response.data));
    },

    initByDocReceivers() {
      if (
        (this.selectedReceiverIds && this.selectedReceiverIds.length) ||
        (this.selectedHandlerIds && this.selectedHandlerIds.length)
      )
        h.each(this.roots, root => this.markCheckedForDocReceivers(root));
    },

    markCheckedForDocReceivers(data) {
      h.each(data.children, child => this.markCheckedForDocReceivers(child));
      if (data.isHandlerNode) {
        let nodeType = data.nodeType;
        if (nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
          if (
            h.exists(
              this.selectedReceiverIds,
              docReceiverId => docReceiverId === data.department.id
            )
          ) {
            this.$set(data, "checked", true);
          }
        } else if (
          nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
        ) {
          if (
            h.exists(
              this.selectedHandlerIds,
              handlerId => handlerId === data.userDeptRole.id
            )
          ) {
            this.$set(data, "checked", true);
          }
        }
      } else {
        let isAllChildNodesChecked = !h.exists(
          data.children,
          child => !child.checked
        );
        this.$set(data, "checked", isAllChildNodesChecked);
      }
    },

    searchTree() {
      this.$refs.departmentTree.filter(this.search);
    },

    selectTags(event) {
      this.selectedTagData = event;
      h.each(this.roots, root => this.markCheckedForSelectedTags(root));
    },

    filterTree(value, data) {
      switch (data.nodeType) {
        case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          return utils.like(data.department.deptName, this.search);
        case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
          return utils.isUserDeptRoleMatchWithQuery(
            data.userDeptRole,
            this.search
          );
        default:
          return false;
      }
    },

    checkedAllChildren(data, checked) {
      h.each(data.children, child => {
        let checkedState = child.checked || false;
        if (checkedState !== checked) {
          this.$set(child, "checked", checked);
          if (child.nodeType !== constants.DEPARTMENT_TREE.NODE_TYPE.DEPT)
            this.checkedAllChildren(child, checked);
        }
      });
    },

    updateCheckedForParent(data) {
      let parent = data.parent;
      if (!parent || parent.isHandlerNode) return;
      let currentCheckedState = parent.checked;
      let newCheckedState = !h.exists(parent.children, child => !child.checked);
      if (currentCheckedState !== newCheckedState) {
        this.$set(parent, "checked", newCheckedState);
        this.updateCheckedForParent(parent);
      }
    },

    markCheckedForSelectedTags(data) {
      h.each(data.children, child => this.markCheckedForSelectedTags(child));
      if (data.isHandlerNode) {
        let nodeType = data.nodeType;
        let selectedHandler;
        if (nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
          let department = data.department;
          selectedHandler = h.find(
            this.selectedTagData,
            item =>
              item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
              department.id === item.department.id
          );
        }
        if (selectedHandler) {
          this.$set(data, "checked", true);
        }
      } else {
        let isExistsDeptInSelectedHashTag = false;
        if (data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
          isExistsDeptInSelectedHashTag = h.exists(
            this.selectedTagData,
            item =>
              item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
              data.department.id === item.department.id
          );
        }

        if (isExistsDeptInSelectedHashTag) {
          this.$set(data, "checked", true);
          this.checkedAllChildren(data, true);
        } else {
          let isAllChildNodesChecked = !h.exists(
            data.children,
            child => !child.checked
          );
          this.$set(data, "checked", isAllChildNodesChecked);
        }
      }
    },

    getNodeLabel(node) {
      return utils.getNodeLabel(node);
    },

    checkedAll(data, checked) {
      this.checkedAllChildren(data, checked);
      this.updateCheckedForParent(data);
    },

    checkedChange(data) {
      this.updateCheckedForParent(data);
    }
  }
};
</script>

<style scoped>
.select-Unit-BanHanh .content {
  padding: 10px 15px;
  padding-bottom: 0;
  border: 1px solid #ceced2;
  border-radius: 4px;
}

.select-Unit-BanHanh .label {
  color: #2d3e4f;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 7px;
}

.select-Unit-BanHanh .content .listCompanies.scroll-scope {
  margin-top: 5px;
  height: 390px;
  position: relative;
  margin-bottom: 10px;
  width: 100%;
}

.select-Unit-BanHanh .content .listCompanies .company_item {
  margin: 10px 0;
}

.select-Unit-BanHanh .content .listCompanies .company_item .name {
  color: #2d3e4f;
  font-weight: 700;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 25px;
}

.tag_select {
  box-shadow: 0px 0.5px 1.5px rgb(0, 0, 0, 0.05);
  transition: all 0.25s;
}

.tag_select:hover {
  transform: translateY(2px);
  text-decoration: underline;
  transition: 0.15s;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/components/banhanh-department-tree.vue